import { CsaRawData, DeaNumFunction, DeaPageFunction } from '../common';
import { csaListProperties, renderStack } from '.';

export const CsaFilterStack = ({
  as,
  totalPages,
  size,
  searchByPage,
  selectedDeaNums,
  save,
}: {
  as: CsaRawData[];
  totalPages: number;
  size: number;
  searchByPage: DeaPageFunction;
  selectedDeaNums: string[];
  save: DeaNumFunction;
}) => {
  return renderStack(csaListProperties)({
    as,
    totalPages,
    size,
    searchByPage,
    selectedDeaNums,
    save,
  });
};
